import styled, { css } from 'styled-components';

import React, {
  useState, useRef, useEffect, useCallback,
} from 'react';

import {
  AnimalRowFieldName,
  AnimalRowFieldValue,
  AnimalRowCheckmark,
  Checkbox,
  BigDisabledCheckbox,
  AnimalRowAddComment,
} from 'src/routes/RegisterSlaughter/Components';
import {
  Label, Row, HTML, Column, LineSeparator,
} from 'src/components/Layout';
import { capitalize } from 'src/utils/string.utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { useOnClickOutside } from 'src/hooks/hooks';
import { colorTypes, getBrandingColor } from 'src/branding';
import { animalAddCommentVariants } from '../util';

export const CommentForAnimalRow = ({
  showComment,
  onChangeComment,
  onToggleComment,
  comment,
  centerComment,
  commentWidth,
  maxLength,
  fullwidth,
  style,
  isReceiptMode,
  center = true,
  ...props
}) => (
  <div style={{ width: '100%', ...style }} {...props}>
    <motion.div
      initial="collapsed"
      animate={showComment ? 'visible' : 'collapsed'}
      variants={animalAddCommentVariants}
    >
      <AnimalRowAddComment
        width={commentWidth}
        fullwidth={fullwidth}
        value={comment}
        isReceiptMode={isReceiptMode}
        center={center}
        onChange={(evt) => onChangeComment(evt.target.value)}
      />
      {maxLength
        && (
          <Label
            style={{
              textAlign: 'center',
              color:
              comment && comment.length > maxLength
                ? getBrandingColor(colorTypes.error)
                : '#4a4a4a',
            }}
          >
            {comment ? comment.length : 0}
            {' '}
            av
            {maxLength}
            {' '}
            tegn
          </Label>
        ) }
    </motion.div>
  </div>
);

export const Wrapper = styled.div`
${({ isReceiptMode }) => isReceiptMode && css`
  max-width: 650px;
  background: white;
  margin: 0 auto;
  margin-top: 1.85em;
  border: 1px solid  #DEDDDB;
  ${Group}{
    background: white;
    border-radius: 0;
    border: none;
    margin-bottom: 0;
  }
  ${CommonFieldsWrapper} .first-field .radio-label-wrapper,  ${GroupName}, ${FormField}, ${Header}, [name="animalRowWrapper"],
  ${CommentHeader}, .comment-for-animal-row-wrapper .comment, .return-form-recceipt-comment{
    padding-left: 2.1rem;
    padding-right: 2.1rem;
    border-left: none;
    border-right: none;

  @media (max-width: 450px){
      padding-left: 1em;
      padding-right: 1em;
  }
  }

  .comment-for-animal-row-wrapper .comment,  .first-field *[name="radio-label-wrapper"]{
    margin: 0;
    padding-top: 0;
  }
  ${GroupName}, ${CommonFieldsWrapper} [name="radio-label-wrapper"], ${CommentHeader}{
    font-weight: 600;
    text-decoration: underline;
    padding-top: 2.2rem;
    padding-bottom: 1.5rem;
    color: black;
    font-size: 1.3em;
    margin: 0;
  }

  ${GroupName},  ${CommentHeader}, ${CommonFieldsWrapper} .first-field {
    border-top: 1px solid  #DEDDDB;
  }

  .skin-meat-field-wrpper{
    [name="valuePart"]{
      margin-left: 0.15em;
    }
  }


  [name="animalRowWrapper"]{
    background: white;
    border: none;
    &:first-child:before{
      border-top: 1px solid #DEDDDB;
      content:"";
      margin-bottom: 1.5em;
      margin-top: -1em;
    }
    &:last-child{
      padding-bottom: 1.42em;
    }
  }
  ${CommentHeader}{
    text-decoration: underline;
    font-weight: 600; 
    font-size: 1.4em;
  }
  ${CommonFieldsWrapper}{
    background: white;
    padding: 0;
  ${FormInfoTxt}{
    *:first-child{
      margin-top: 0;

    }
  }
}
`}`;

export const GroupName = styled.div`
  font-weight: bold;
  font-size: 1.3em;
  background: white;
  padding: 1rem;
  border-radius: inherit;
  position: relative;

  &:hover {
    ${({ disableHoverEffect }) => !disableHoverEffect
      && css`
        cursor: pointer;
        text-decoration: underline;
      `};
  }
`;

export const FormDescription = styled.p``;
export const Group = styled.div`
  border: thin solid #e0e0e0;
  border-radius: 4px;
  background: #f5f5f5;
  margin-bottom: 2.5em;
  color: black;
  @media screen and (max-width: 680px) {
    min-width: fit-content;
  }

  ${({ isDefaultGroup }) => !isDefaultGroup && css`
    border-top: 2px solid #0b479e;
    border-bottom: 2px solid #0b479e;
  `}


  ${({ isDefaultGroup }) => isDefaultGroup
&& css`
  ${AnimalRowWrapper}{
    background-color: white;
  }
`
}

`;

export const GrpupNameAndFields = styled.div`
  background: white;
  border-radius: inherit;
  padding-bottom: 0.5rem;
`;
export const ActionButton = styled.button`
  font-size: 1em;
  padding: 0.5em 1em;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  &:hover {
    cursor: pointer;
  }

  &:active{
    color: black;
  }
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  right: 0;
  border-radius: 4px;
  background: white;
`;
export const DropdownLabel = styled.div`
  padding: 0.6em;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  border-radius: inherit;

  &:hover {
    cursor: pointer;
  }
`;

export const FormFieldLabel = styled.label`
  color: #424242;
  margin-left: 0.3rem;
  font-size: 1.23rem;
  font-weight: bold;
`;

export const RadioButtonWrapper = styled.div`
  margin-right: 0.6em;
  .check {
    height: 1.75em;
    width: 1.75em;
    border-radius: 50%;
    background: white;
    border: 1px solid #c2c2c2;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }

    .dot-icon{
      color: #0b479e;
      font-size: 1.2rem;
      display: none;
    }
    .dot {
      background: #0b479e;
      border-radius: 50%;
      width: 50%;
      height: 50%;
      display: none;
    }
  }
  input:checked ~ .check .dot {
    display: block;
  }

  input:checked ~ .check .dot-icon {
    display: block;
  }

  ${({ isReceiptMode }) => isReceiptMode && css`
    .check{
      border: none;
      background: none;
      &:hover{
        cursor: default;
      }
      &.is-not-checked{
        .dot{
          display: block;
          background: #b0b0b0;
        }
        .dot-icon{
          display: block;
          color: #b0b0b0;
        }
      }
    }
  `}
`;

const RadioButtonLabel = styled.label`
  display: flex;
  margin-bottom: 0.6em;
  align-items: center;
`;

export const RadioButton = ({
  name, label, checked, isReceiptMode, id, ...props
}) => (
  <RadioButtonLabel {...props}>
    <RadioButtonWrapper isReceiptMode={isReceiptMode}>
      <input
        style={{ display: 'none' }}
        type="radio"
        checked={checked}
        disabled={isReceiptMode}
        id={id}
        name={name}
      />
      <div className={`check ${checked ? 'is-checked' : 'is-not-checked'}`}>
        {isReceiptMode
          && <FontAwesomeIcon className="dot-icon" icon={checked ? faCheckCircle : faCircle} />
          || <div className="dot" />}
      </div>
    </RadioButtonWrapper>
    <FormFieldLabel style={{ fontSize: '1.1em' }} htmlFor={id}>{label}</FormFieldLabel>
  </RadioButtonLabel>
);

export const FormFields = ({
  fields,
  groupId,
  formData,
  onFieldChange,
  illegalCheckboxCombinations,
  isReceiptMode,
  noLeftPadding,
}) => {
  const dontShowRadioGroupWithoutValueFilter = (field, formData) => {
    if (!formData || field.kind !== 'radio-group') {
      return;
    }
    return field.radio_buttons.find((r) => formData[r.id]);
  };

  return (
    <FormFieldsWrapper>

      {/* If checkbox and receipt-mode, only show checkboxes that acually have a value(true/false).
      This is because some checkboxes may not have been relevant in the enrolment, and therefore not selected/deselected. We dont want to show these in receipt-mode.
    */}
      {fields.filter((f) => (isReceiptMode && dontShowRadioGroupWithoutValueFilter(f, formData)) || !isReceiptMode).map((f, fIdx) => (
        <FormField key={f.id} noLeftPadding={noLeftPadding} className={fIdx === 0 ? 'first-field' : ''}>
          {
            {
              checkbox: (
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {((illegalCheckboxCombinations
                      && illegalCheckboxCombinations.find(
                        (illegal) => formData
                          && formData[illegal.checkbox_id]
                          && illegal['illigal-combined-with-oneof-ids'].includes(
                            f.id,
                          ),
                      )) || isReceiptMode)
                        && (formData && !formData[f.id] && <BigDisabledCheckbox isReceiptMode={isReceiptMode} />)
                      || (
                        <Checkbox
                          big
                          inline
                          checked={formData && formData[f.id]}
                          name={groupId + f.id}
                          label={' '}
                          disabled={isReceiptMode}
                          isReceiptMode={isReceiptMode}
                          onChange={(evt) => {
                            if (isReceiptMode) {
                              return false;
                            }
                            const checked = evt.target.checked;
                            onFieldChange({
                              groupId,
                              fieldId: f.id,
                              value: checked,
                            });
                          }}
                        />
                      )}

                    <FormFieldLabel htmlFor={f.id}>{f.title}</FormFieldLabel>
                  </div>
                  <FormFieldHelpText>
                    {' '}
                    <HTML>{f['info-txt'] || ''}</HTML>
                    {' '}
                  </FormFieldHelpText>
                </>
              ),

              'radio-group': (
                <div style={{ marginBottom: '2.1em' }}>
                  {f.title
                  && (
                    <p
                      name="radio-label-wrapper"
                      style={isReceiptMode ? {} : {
                        fontSize: '1.4em',
                        marginBottom: '0.5em',
                      }}
                    >
                      {f.title}

                    </p>
                  ) }
                  {f.radio_buttons
                    && f.radio_buttons.map((r, idx) => (
                      <React.Fragment key={r.id}>
                        <RadioButton
                          style={{ marginBottom: r['info-txt'] ? 0 : '0.8em' }}
                          id={r.id}
                          name={groupId + f.id}
                          label={r.title}
                          checked={(formData && formData[r.id] === undefined && idx === 0 && !isReceiptMode) || (formData && formData[r.id])}
                          isReceiptMode={isReceiptMode}
                          onClick={() => onFieldChange({
                            groupId,
                            fieldId: r.id,
                            uncheckFieldIds: f.radio_buttons.filter((rbutton) => r.id !== rbutton.id).map((r) => r.id),
                            value: true,
                          })}
                        />

                        {r['info-txt'] && (
                          <FormFieldHelpText className="helptext" style={{ marginBottom: '1.1em' }}>
                            {' '}
                            <HTML>{r['info-txt']}</HTML>
                            {' '}
                          </FormFieldHelpText>
                        )}
                      </React.Fragment>
                    ))}
                </div>
              ),
              text: (
                <HTML style={{ marginBottom: '1.76em', display: 'block', fontSize: '1.1rem' }}>{f.text}</HTML>
              ),
            }[f.kind]
          }
        </FormField>
      ))}
    </FormFieldsWrapper>
  );
};

export const DropdownitemsWrapper = styled.div`
  border: 1px solid #e0e0e0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: white;
  top: 0;
  position: absolute;
`;

export const CommentHeader = styled.div`
  font-size: 1em;
  font-weight: bold;
`;
export const DropdownItem = styled.div`
  padding: 0.7em;

  &:hover {
    cursor: pointer;
  }
`;

export const FormFieldsWrapper = styled.div``;
export const FormInfoTxt = styled.div``;
export const FormFieldHelpText = styled.p`
  color: #616161;
  margin-top: 0.5rem;
  margin-bottom: 1.75rem;
`;

export const FormField = styled.div`
  padding-left: 1.25em;
  padding-right: 0.75em;
  ${({ noLeftPadding }) => noLeftPadding && css`
    padding-left: 0;
  `}
`;

export const GroupToggle = styled.div``;

export const AnimalRowAndButtonsWrapper = styled.div`
  position: relative;
  border-radius: inherit;
`;

export const AnimalRowField = styled.div`
  margin-right: 1em;
  margin-bottom: 0.1em;
  display: flex;
  align-items: center;

  @media screen and (max-width: 500px) {
    [name='splitLinesOnMobile'] {
      flex-wrap: wrap;
      flex-basis: 0%; /*force on separate lines*/
    }
    [name='actionButtonsRow'] {
      max-width: 80%;
    }
  }
`;

export const Dropdown = ({
  items, label, onChange, ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const wrapperRef = useRef();
  useOnClickOutside(() => setIsOpen(false), [wrapperRef]);

  const handleSelect = (val) => {
    setIsOpen(false);
    onChange(val);
  };
  return (
    <DropdownWrapper className="dropdownWrapper" {...props} ref={wrapperRef}>
      <DropdownLabel
        onClick={() => setIsOpen((old) => !old)}
        className="dropdownLabel"
      >
        <HTML>{label}</HTML>
      </DropdownLabel>
      {isOpen && (
        <DropdownitemsWrapper className="dropdownitemswrapper">
          {items.map((item) => (
            <DropdownItem
              className="dropdownItems"
              onClick={() => handleSelect(item.value)}
            >
              <HTML>{item.label}</HTML>
            </DropdownItem>
          ))}
        </DropdownitemsWrapper>
      )}
    </DropdownWrapper>
  );
};

const AnimalRowWrapper = styled(Column)`
  max-width: 960px;
  margin-left: 0;
  margin-right: 0;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  border-radius: ${({ isChecked }) => (isChecked ? 'none' : 'inherit')};

  @media screen and (max-width: 400px) {
    left: 0%;
    transform: none;
  }

  .check-and-name {
    display: flex;
  }
  .animal-kind-label{
    width: 92px;
    margin-right: 1em;
  }
  .fields-wrapper{
    display: flex;
    flex-wrap: wrap;
  }
  .cattle-mark{
    ${AnimalRowFieldName}{
      white-space: nowrap;
    }
    .mark-and-slash{
      white-space: nowrap;
    }

  }

  @media screen and (max-width: 680px) {
    border-top: 1px solid #eaeaea;
    padding-right: 0;

  .animal-kind-label{
    width: 50px;
    margin-right: 0.95em;
    white-space: nowrap;
  }

  .cattle-mark{
    flex-wrap: wrap;
    width: min-content;
  }

  ${AnimalRowAndButtonsWrapper}{
    padding-left: 0.7em;
  }

    .content-wrapper {
      justify-content: space-between;
      .fields-wrapper {
        flex-direction: column;
        margin-left: auto;
        margin-right: 0;
        margin-left: 0;
    width: min-content;
    min-width: 150px;

        > * {
          margin-bottom: 0.3em;
          margin-right: 0;
        }
      }
    }
  }
`;

export const AnimalRowWrapperReturnForm = styled(AnimalRowWrapper)`
  .fields-wrapper{
    min-width: 120px;
  }
`;

export const AnimalRow = ({
  animal, animalKind, disabledFields, isChecked, hideCheckbox, onCheckChange, isReceiptMode, rowIdx, groupId, wrapperStyleMobile, moveBetweenGroupsEnabled,
}) => {
  const hasReturnMeat = (animal.return_meat === true
    || Array.isArray(animal.return_meat)
    || isNaN(parseInt(animal.return_meat)) === false);
  return (
    <AnimalRowWrapper
      width="100%"
      margin="auto"
      name="animalRowWrapper"
      paddingTop="0.85em"
      paddingBottom="0.85em"
      marginLeft="30px"
      paddingLeft="1.25em"
      paddingRight="1.25em"
      background={isChecked ? ' #A5CEFF' : '#F5F5F5'}
      isChecked={isChecked}
      style={{ boxSizing: 'border-box' }}
      wrapperStyleMobile={wrapperStyleMobile}
    >
      <Row grow align="center" marginLeft="0.15em" marginRight="0.15em" className="content-wrapper">
        <div className="check-and-name">
          {!isReceiptMode && !hideCheckbox && moveBetweenGroupsEnabled
        && (
          <Checkbox
            medium
            checked={isChecked}
            name={`return_form_move_check${animal.animal_row_id}_${rowIdx}_${groupId}`}
            labelStyle={css`
            overflow: visible;
          `}
            label={' '}
            onChange={(evt) => {
              const checked = evt.target.checked;
              onCheckChange(checked);
            }}
          />
        ) }

          <Label
            className="animal-kind-label"
            color="#000000"
            bold
            size="1.25em"
            marginLeft="0.55em"
          >
            {capitalize(
              animal.subcategory_name
              || (animalKind === 'cattle'
                ? 'Storfe'
                : animalKind === 'sheep'
                  ? 'Småfe'
                  : 'Gris'),
            )}
          </Label>
        </div>

        <div className="fields-wrapper">
          {animal.ear_tag && (
            <AnimalRowField>
              <AnimalRowFieldName>Ørenummer: </AnimalRowFieldName>
              <AnimalRowFieldValue>{animal.ear_tag}</AnimalRowFieldValue>
            </AnimalRowField>
          )}
          {animal.individual_no && !animal.mark_no && (
            <AnimalRowField>
              <AnimalRowFieldName>Individnummer: </AnimalRowFieldName>
              <AnimalRowFieldValue>{animal.individual_no}</AnimalRowFieldValue>
            </AnimalRowField>
          )}
          {animal.mark_no && animal.individual_no && (
            <AnimalRowField className="cattle-mark">
              <AnimalRowFieldName name="animalRowCattleMarkHeader">
                Merkenr / Individnr:
              </AnimalRowFieldName>

              <div name="animalRowCattleMarkData" className="cattle-mark-value">

                <Label inline style={{ verticalAlign: 'baseline' }} className="mark-and-slash">
                  {animal.mark_no}
                  {' '}
                  /
                  {' '}
                </Label>
                <Label inline style={{ verticalAlign: 'baseline' }}>
                  {animal.individual_no}
                </Label>

              </div>
            </AnimalRowField>
          )}
          {animal.sheep_individual_no && (
            <AnimalRowField>
              <AnimalRowFieldName>Individnr:</AnimalRowFieldName>
              <AnimalRowFieldValue>
                {animal.sheep_individual_no}
              </AnimalRowFieldValue>
            </AnimalRowField>
          )}
          {animal.club_no > 0 && (
            <AnimalRowField>
              <AnimalRowFieldName>Klubbenummer:</AnimalRowFieldName>
              <AnimalRowFieldValue>{animal.club_no}</AnimalRowFieldValue>
            </AnimalRowField>
          )}

          {!(disabledFields || []).includes('count')
          && (
            <AnimalRowField>
              <AnimalRowFieldName>Antall:</AnimalRowFieldName>
              {/* Sheep, cattle and purke/raane are always individual, so the count is therefor always 1 */}
              {/* Pigs(not purke/raane) are grouped */}
              <AnimalRowFieldValue>{ animal.amount_for_row}</AnimalRowFieldValue>
            </AnimalRowField>
          ) }

          {hasReturnMeat && (
            <AnimalRowField className="skin-meat-field-wrpper">
              <AnimalRowFieldName>
                {isReceiptMode
                && (
                  <Checkbox
                    isReceiptMode
                    label=" "
                    disabled
                    big
                    inline
                    customColor="black"
                    customMarginRight="0em"
                    customMarginLeft="-0.31rem"
                    name={`${animal.uid}check_returmeat`}
                    checked
                    onChange={() => {}}
                  />
                )
              || <AnimalRowCheckmark wrapperStyle={{ left: '0' }} />}
              </AnimalRowFieldName>
              <AnimalRowFieldValue style={{ marginLeft: '-0.17em' }}>Returkjøtt</AnimalRowFieldValue>
            </AnimalRowField>
          )}
          {(Number.isInteger(animal.return_skin) || animal.return_skin === true) && (
            <AnimalRowField className="skin-meat-field-wrpper">
              <AnimalRowFieldName>
                {isReceiptMode
                && (
                  <Checkbox
                    isReceiptMode
                    label=" "
                    disabled
                    big
                    customColor="black"
                    customMarginRight="0em"
                    customMarginLeft={!animal.hasReturnMeat ? '-0.31rem' : '0'}
                    inline
                    name={`${animal.uid}check_returnskin`}
                    checked
                    onChange={() => {}}
                  />
                )
                || <AnimalRowCheckmark wrapperStyle={{ left: '0' }} />}
              </AnimalRowFieldName>
              <AnimalRowFieldValue style={{ marginLeft: '-0.17em' }}>
                {(animalKind === 'cattle') && 'Returhud' || (animalKind === 'sheep' && 'Returskinn') }
              </AnimalRowFieldValue>
            </AnimalRowField>
          )}
        </div>
      </Row>
    </AnimalRowWrapper>
  );
};

export const Header = styled(Group)`
  background: none;
  margin: 0;
    font-size: 1.55em;
    padding: 1.55rem 1.75rem;
    font-weight: bold;
    border-bottom: 1px solid #DEDDDB;

`;

export const CommonFieldsWrapper = styled.div``;
